// import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    firstName: '',
    middleInitial: '',
    lastName: '',
    suffix: '',
    positions: [],
    filerStatus: [],
  },
  mutations: {
  },
  actions: {
  },
};